(() => {
  if (window.fjBlackMonthOffers) return;
  window.fjBlackMonthOffers = true;
  const numberFormat = new Intl.NumberFormat(document.documentElement.lang || 'nb');
  const parts = numberFormat.formatToParts(1234.5);
  const decimal = parts.find(part => part.type === 'decimal')?.value || ',';
  const amount = node => {
    if (!node) return NaN;
    let value = node.textContent.replace(/[^\d.,]/g, '');
    if (decimal === ',') value = value.replaceAll('.', '').replace(',', '.');
    else value = value.replaceAll(',', '');
    return value ? Math.round(Number(value) * 100) : NaN;
  };
  const setText = (node, value) => {
    if (node.textContent !== value) node.textContent = value;
  };
  function heading(container, settings) {
    let header = container.querySelector(':scope > .fj-bm-offer-heading');
    if (!header) {
      header = document.createElement('div');
      header.className = 'fj-bm-offer-heading';
      const title = document.createElement('strong');
      title.textContent = settings.fjBmCampaign;
      const caption = document.createElement('span');
      caption.textContent = settings.fjBmChoose;
      header.append(title, caption);
      container.prepend(header);
    }
    return header;
  }
  function saving(container, price, reference, settings) {
    const current = amount(price), original = amount(reference);
    const percent = original > current && current >= 0 ? Math.floor((original - current) * 100 / original) : 0;
    let badge = container.querySelector(':scope > .fj-bm-saving');
    if (!percent) {
      badge?.remove();
      container.classList.remove('fj-bm-has-saving');
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'fj-bm-saving';
      container.append(badge);
    }
    setText(badge, settings.fjBmSaving.replace('[percentage]', numberFormat.format(percent)));
    container.classList.add('fj-bm-has-saving');
  }
  function update() {
    document.querySelectorAll('.product__info-container').forEach(info => {
      const config = info.querySelector('.fj-bm-product');
      if (!config) return;
      const settings = config.dataset;
      const bundles = info.querySelectorAll('.kaching-bundles__block');
      const offers = info.querySelectorAll('.df-offer[data-df-offer]');
      const nativeBundle = info.querySelector('.hv-bundle');
      bundles.forEach(block => {
        block.classList.add('fj-bm-bundles');
        heading(block, settings);
        block.querySelectorAll('.kaching-bundles__bar').forEach(bar => {
          const content = bar.querySelector('.kaching-bundles__bar-content-left');
          if (content) saving(content, bar.querySelector('.kaching-bundles__bar-price'), bar.querySelector('.kaching-bundles__bar-full-price'), settings);
        });
      });
      offers.forEach(offer => {
        heading(offer, settings);
        offer.querySelectorAll('.df-package').forEach(card => saving(card, card.querySelector('.df-package-price'), card.querySelector('.df-package-compare'), settings));
      });
      if (nativeBundle) {
        heading(nativeBundle, settings);
        const item = nativeBundle.querySelector('.hv-bundle__item');
        const price = item?.querySelector('.hv-bundle__price');
        if (price) saving(price, item.querySelector('.hv-bundle__now'), item.querySelector('.hv-bundle__wasline s'), settings);
      }
      const fallback = info.querySelector('.df-purchase, product-form');
      const oldFallback = info.querySelector('.fj-bm-purchase-heading');
      if (bundles.length || offers.length || nativeBundle) oldFallback?.remove();
      else if (fallback) {
        let holder = oldFallback;
        if (!holder) {
          holder = document.createElement('div');
          holder.className = 'fj-bm-purchase-heading';
          fallback.before(holder);
        }
        const header = heading(holder, settings);
        const sale = info.querySelector('.price--on-sale');
        saving(header, sale?.querySelector('.price-item--sale'), sale?.querySelector('.price__sale .price-item--regular'), settings);
      }
    });
  }
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  };
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(records => {
    if (records.some(record => !record.target.closest?.('.fj-bm-offer-heading, .fj-bm-saving'))) schedule();
  }).observe(main, { childList: true, subtree: true, characterData: true });
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  update();
})();
